/**
 * Visibilité fiche produit — création optimisée (Lot 1 recadré).
 * Référence : docs/platform/PRINCIPES-DIRECTEURS-FICHE-PRODUIT.md
 *
 * Cœur métier toujours visible ; modes spécialisés révélés à la demande.
 */

import { PRODUCT_SECTION_KEYS as S } from './produitSectionKeys.js';

/** Sections visibles par défaut à la création (cœur métier). */
export const CREATION_CORE_SECTIONS = Object.freeze([
  S.PHOTOS,
  S.INFOS,
  S.PRIX,
  S.CATEGORIE,
  S.STOCK,
  S.OPTIONS,
  S.BADGES,
  S.INGREDIENTS,
]);

/** Sections masquées par défaut (spécialisées / rares). */
export const CREATION_HIDDEN_SECTIONS = Object.freeze([
  S.PLANCHE_PERSONNES,
  S.VENTE_AU_POIDS,
  S.COMPOSITION_PIECES,
  S.ELEMENTS_COMPOSABLES,
  S.LIEN_PLATEAUX,
  S.CHAMPS_METIER,
  S.TEMPLATES,
]);

/** Raccourcis « Cas particuliers » → sections à révéler. */
export const CREATION_SHORTCUT_BUNDLES = Object.freeze({
  plateau: [S.COMPOSITION_PIECES, S.ELEMENTS_COMPOSABLES],
  planche: [S.PLANCHE_PERSONNES],
  poids: [S.VENTE_AU_POIDS],
});

const CORE_SET = new Set(CREATION_CORE_SECTIONS);

/**
 * @param {string} sectionKey
 * @param {{ showAllSections?: boolean, revealedSections?: Set<string> }} options
 */
export function shouldShowCreationSection(sectionKey, options = {}) {
  const { showAllSections = false, revealedSections = new Set() } = options;
  if (showAllSections) return true;
  if (CORE_SET.has(sectionKey)) return true;
  if (revealedSections.has(sectionKey)) return true;
  return false;
}

export function getCreationShortcutSections(shortcutId) {
  return CREATION_SHORTCUT_BUNDLES[shortcutId] ?? [];
}
